import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { getScrollbarWidth } from '../../../lib/helpers';
import { ISeedDivider } from '../../../infrastructure/interfaces'
import { getSeedDividers, editSeedDivider} from '../../../actions/actions'
import HeaderBar from '../../HeaderBar/HeaderBar';
import SeedDividerEditorModal from '../../Modals/SeedDividerEditorModal/SeedDividerEditorModal'
import { contentImagesRelativePath } from '../../../constants';
import {TooltipCont} from "../../../infrastructure/tooltips";

export interface IManageFullPageCatalogImagesProps {
    seedDividers?: ISeedDivider[];
    editSeedDivider(divider: ISeedDivider, formData: FormData): void;
    getSeedDividers(): void;
    onCreate(): void;
}

export interface IManageFullPageCatalogImagesState {
    selectedSeedDivider?: ISeedDivider;
    showSeedDividerEditorModal: Boolean
}

const mapStateToProps = (state: any) => {
    return {
        seedDividers: state.seedDividerList,
    };
};

const mapDispatchToProps = (dispatch: any): any => {
    return {
        getSeedDividers: () => {
            dispatch(getSeedDividers());
        },
        editSeedDivider: (divider: ISeedDivider, formData: FormData) => {
            dispatch(editSeedDivider(divider, formData));
        }
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManageSeedDividersTable extends React.Component<IManageFullPageCatalogImagesProps, IManageFullPageCatalogImagesState> {
    tableRow: HTMLElement;
    constructor(props: IManageFullPageCatalogImagesProps) {
        super(props);
        this.state = {
            showSeedDividerEditorModal: false
        };

        // Bind methods
        this.closeModals = this.closeModals.bind(this)
        this.editSeedDivider = this.editSeedDivider.bind(this)
    }

    componentDidMount() {
        this.props.getSeedDividers();
    }

    onEditSeedDivider(divider: ISeedDivider) {
        this.setState({
            selectedSeedDivider: divider,
        }, () => this.setState({
            showSeedDividerEditorModal: true,
        }));
    }

    editSeedDivider(divider: ISeedDivider, formData: FormData) {
        this.props.editSeedDivider(divider, formData)
    }

    closeModals() {
        this.setState({
            showSeedDividerEditorModal: false,
            selectedSeedDivider: undefined
        });
    }

    render() {

        const {
            seedDividers,
        } = this.props;
        const nonNullSeedDividers = seedDividers ? seedDividers : [];

        return (
            <div className="root-container">
                <HeaderBar />
                <div className="inner-su-container">
                    <div className="manage-items-row">

                    <div className="in-row-text-container">
                        Manage Seed Divider Pages
                    </div>
                    </div>
                    <table className="table-scrollableSU documents-table">
                        <thead style={{ paddingRight: getScrollbarWidth() }}>
                        <tr>
                            <th>Name</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="document-table-body">
                            {nonNullSeedDividers.map((t: ISeedDivider) =>

                            <tr key={t.id} ref={tr => this.tableRow = tr!}>
                                <td>
                                    {t.category.name}
                                </td>
                                <td>
                                    <img
                                        hidden={t.image_path.length <= 1}
                                        className="inlineImagesTableImage"
                                        src={contentImagesRelativePath + t.image_path}
                                    />
                                </td>
                                <td>
                                    <div className="button-wrapper">
                                        <button
                                            className="btn primary-blue"
                                            onClick={() => {
                                                this.onEditSeedDivider(t)
                                            }}
                                            title={TooltipCont.EDIT}
                                            disabled={false}
                                        >
                                             Edit
                                        </button>
                                    </div>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <SeedDividerEditorModal
                    show={this.state.showSeedDividerEditorModal}
                    selectedDivider={this.state.selectedSeedDivider}
                    onClose={this.closeModals}
                    onSubmit={(divider: ISeedDivider, formData: FormData) => {
                            this.editSeedDivider(divider, formData);
                            this.closeModals();
                        }
                    }
                />
            </div>
        );
        }
    }



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageSeedDividers.tsx